// 旧项目仍使用「数组首项在最上层」的结构，操作只发生在真实父级内。
export function locateNode (nodes, id, ancestors = []) {
  for (let index = 0; index < nodes.length; index++) {
    const node = nodes[index]
    if (node.index === id) return { node, siblings: nodes, index, ancestors }
    if (node.children) {
      const found = locateNode(node.children, id, ancestors.concat(node))
      if (found) return found
    }
  }
  return null
}

export function selectedRoots (nodes, ids) {
  const selected = new Set(ids)
  return Array.from(selected).map(id => locateNode(nodes, id)).filter(item =>
    item && !item.ancestors.some(node => selected.has(node.index)))
}

function hasLockedChild (node) {
  return !!node.locked || (node.children || []).some(hasLockedChild)
}

export function canEditNode (item) {
  return !!item && !item.ancestors.some(node => node.locked) && !hasLockedChild(item.node)
}

export function removeNodes (nodes, ids) {
  const removed = []
  selectedRoots(nodes, ids).filter(canEditNode).forEach(item => {
    const index = item.siblings.indexOf(item.node)
    if (index !== -1) removed.push(item.siblings.splice(index, 1)[0])
  })
  return removed
}

export function reorderNode (nodes, id, action) {
  const item = locateNode(nodes, id)
  if (!canEditNode(item)) return false
  const target = { up: Math.max(0, item.index - 1), down: Math.min(item.siblings.length - 1, item.index + 1),
    top: 0, bottom: item.siblings.length - 1 }[action]
  if (target === undefined || target === item.index) return false
  item.siblings.splice(item.index, 1)
  item.siblings.splice(target, 0, item.node)
  return true
}

export function cloneNodes (nodes, createId, offset = { x: 20, y: 20 }, { preserveLocks = false } = {}) {
  const copies = JSON.parse(JSON.stringify(nodes))
  const ids = new Map()
  const walk = (items, callback) => items.forEach(node => {
    callback(node)
    if (node.children) walk(node.children, callback)
  })
  walk(copies, node => {
    const id = createId()
    ids.set(node.index, id)
    node.index = id
    if (!preserveLocks) node.locked = false
    if (!node.children) {
      node.left = Number(node.left || 0) + offset.x
      node.top = Number(node.top || 0) + offset.y
    }
  })
  walk(copies, node => {
    if (node.child && Array.isArray(node.child.index)) {
      node.child.index = node.child.index.map(id => ids.get(id) || id)
    }
  })
  return copies
}

export function isTextEditing (target) {
  return !!(target && target.closest && target.closest('input, textarea, select, [contenteditable="true"], .CodeMirror, [role="dialog"]'))
}
